import { getCurrentCookie } from 'core/util/storage'

export class MarketingGTMHelper {
  private gl = ''

  constructor(gtagId: string | null) {
    this.gl = gtagId ? this.createCrossDomainGl(gtagId) : ''
  }

  checkAvailability() {
    return !!window.dataLayer
  }

  getGl() {
    return this.gl
  }

  private createCrossDomainGl(gtagId: string) {
    try {
      if (window.google_tag_data && window.google_tag_data.glBridge) {
        const mId = gtagId.replace('G-', '')
        const currentGaCookie = getCurrentCookie('_ga')
        const currentGaMIdCookie = getCurrentCookie(`_ga_${mId}`)
        const gaCookie: string = Array.isArray(currentGaCookie)
          ? currentGaCookie[0]
          : currentGaCookie
        const gaMIdCookie: string = Array.isArray(currentGaMIdCookie)
          ? currentGaMIdCookie[0]
          : currentGaMIdCookie
        const cookieObject: {
          [key: string]: string
        } = {
          _ga: gaCookie?.substr(6),
        }
        cookieObject[`_ga_${mId}`] = gaMIdCookie?.substr(6)

        const gl = window.google_tag_data.glBridge.generate(cookieObject)
        if (gl) {
          window.dataLayer?.push({
            event: 'gl_ready',
            gtagApiResult: {
              _gl: gl,
            },
          })
        }
        return gl
      }
    } catch (error) {
      console.log('_gl creation error', error)
      return ''
    }
  }
}
